import axios from "axios";
import { UserReadDto } from "../interface";
import { processAxiosError } from "../processAxiosError";
import { IUsersReturn } from "./getAllUsers";

/**
 * Searches for users.
 *
 * @param backEndUrl - The backend API base URL for making HTTP requests
 * @param searchText - The search term to find matching users
 * @param controller - Optional AbortController for cancelling the request
 * @returns A promise resolving to `IUsersReturn` with matching users when successful.
 */
export const searchUsers = async (
  backEndUrl: string,
  searchText: string,
  controller?: AbortController,
): Promise<IUsersReturn> => {
  const url = `${backEndUrl}Users/search?search=${searchText}`;
  // Get data
  try {
    const response: { data: UserReadDto[] } = await axios.get(
      url,
      controller !== undefined ? { signal: controller.signal } : undefined,
    );
    // Return successful result
    return { success: true, data: response.data };
  } catch (error: unknown) {
    return processAxiosError("Load all users failed", error);
  }
};
